import {
  Text,
  Box,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';

import {IconAlertCircle,} from '../../../../../styles/icons';
import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import UploadVideo from '../common-forms/UploadVideo';

const EditSectionProfileVideo = ({ profile }) => {
  const {profileVideo} = profile;

  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            textAlign="left"
          >
            <Box>
              <Text>Intro video</Text>
              <Text textStyle="footer2" color="brand.200">
                {profileVideo?.length > 0 ? 'Added' : 'None added'}
              </Text>
            </Box>
            {profileVideo !== null && profileVideo !== {} ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Adding an introductory video helps you stand out
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <div className="flex flex-col rounded items-start gap-6 w-full bg-white p-4">
          <div className="w-full">
            <Text textStyle="h6">
              Adding a short video to introduce yourself gives your potential
              clients a much better feel for you as a person and helps to
              convert contacts.<br></br>
              <br></br>
              Please keep your video very brief - under 30 seconds is perfect. Include who you are, a greeting, what you
              specialise in and ideally a call to action to make a booking. For the best results, make sure that the
              video is in landscape format.
            </Text>
            <UploadVideo profile={profile} />
          </div>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionProfileVideo;
